import { useTranslation } from 'react-i18next';
import { DoughnutChart } from 'src/common/components/Graphs/common/Graphs/DoughnutChart';
import { useActiveInSessionData } from './hooks/useActiveInSessionData';

type ActiveInSessionChartProps = {
  accountRef: string;
};

export const ActiveInSessionChart = (props: ActiveInSessionChartProps) => {
  const { t } = useTranslation();

  const { chartData, total } = useActiveInSessionData(props);

  return (
    <DoughnutChart
      data={chartData}
      total={total}
      aria-label={t('dashboard.activeInSessionChart.title')}
    />
  );
};
